var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-icon-alert"},[_c('div',{staticClass:"alert-icon"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$icon('light'))}})]),_vm._v(" "),_c('div',{staticClass:"alert-body",domProps:{"innerHTML":_vm._s(_vm.info)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }